<div>
  <div>
    <div class="d-flex" style="gap: var(--form-gap)">
      <div class="unity-form-group select" style="margin-bottom: 0">
        <ep-dropdown
          [disabled]="controlDisabled"
          [codeValues]="subLocationCodeTable$ | async"
          [(ngModel)]="value"
          (blur)="onBlur()"
          (focus)="onFocus()"
          style="width: 100%"
        ></ep-dropdown>
      </div>
      <button unity-button
        *ngIf="!userDefinedMode"
        classes="icon-only"
        class="d-flex align-items-center"
        (click)="modalEdit()"
        [ngbTooltip]="value && value > '' ? 'Edit Sub Location' : 'Add Sub Location'"
        type="button"
        [hidden]="controlDisabled"
        [disabled]="controlDisabled"
        tabindex="-1"
      >
        <svg class="unity-icon unity-icon-pencil" *ngIf="value && value > ''">
          <use xlink:href="#unity-icon-pencil"></use>
        </svg>
        <svg class="unity-icon unity-icon-plus" *ngIf="!(value && value > '')">
          <use xlink:href="#unity-icon-plus"></use>
        </svg>
      </button>
    </div>
  </div>
</div>
